<template>
  <div class="solution section0">
    <div class="banner">
      <div class="w1200">
        <h3>乡村振兴数字化解决方案</h3>
        <p>
          <span>发展数字农业</span>
          <span>助力乡村振兴</span>
        </p>
      </div>
    </div>
    <div class="container w1200">
      <h3>发展数字农业是决定乡村振兴的有力支撑</h3>
      <div class="desc">
        <p>以习近平新时代中国特色社会主义思想为指导，全面贯彻党的十九大和十九届二中、三中、四中全会精神，按照实施数字中国战略、乡村振兴战略、数字乡村战略的总体部署，以产业数字化、数字产业化为发展主线，以数字技术与农业农村经济深度融合为主攻方向，以数据为关键生产要素，着力建设基础数据资源体系，加强数字生产能力建设，加快农业农村生产经营、管理服务数字化改造，强化关键技术装备创新和重大工程设施建设，推动政府信息系统和公共数据互联开放共享，全面提升农业农村生产智能化、经营网络化、管理高效化、服务便捷化水平，用数字化引领驱动农业农村现代化，为实现乡村全面振兴提供有力支撑。</p>
      </div>
    </div>
    <div class="d_footer1">
      <h3>发展数字农业的基本原则</h3>
      <ul class="clear">
        <li>
          <div class="img"></div>
          <p>
            <span>统筹谋划</span>
            <span>有序推进</span>
          </p>
        </li>
        <li>
          <div class="img"></div>
          <p>
            <span>数据驱动</span>
            <span>普惠共享</span>
          </p>
        </li>
        <li>
          <div class="img"></div>
          <p>
            <span>创新引领</span>
            <span>应用导向</span>
          </p>
        </li>
        <li>
          <div class="img"></div>
          <p>
            <span>多方参与</span>
            <span>合力共建</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="d_footer2">
      <h3>数字农业发展目标</h3>
      <p
        class="desc"
      >到2025年，数字农业农村建设取得重要进展，有力支撑数字乡村战略实施。农业农村数据采集体系建立健全，天空地一体化观测网络、农业农村基础数据资源体系、农业农村云平台基本建成。数字技术与农业产业体系、生产体系、经营体系加快融合，农业生产经营数字化转型取得明显进展，管理服务数字化水平明显提升，农业数字经济比重大幅提升，乡村数字治理体系日趋完善。</p>
      <ul class="clear">
        <li>
          <div class="img"></div>
          <p>天空地一体化观测网络</p>
        </li>
        <li>
          <div class="img"></div>
          <p>农业农村基础数据资源体系</p>
        </li>
        <li>
          <div class="img"></div>
          <p>农业农村云平台</p>
        </li>
      </ul>
    </div>
    <div class="d_footer3">
      <h3>乡村振兴数字化解决方案</h3>
      <p
        class="desc"
      >以产业数字化、数字产业化为发展主线，以数字技术与农业农村经济深度融合为主攻方向，以数据为关键生产要素着力建设基础数据资源体系，加强数字生产能力建设，加快农业农村生产经营、管理服务数字化改造全面提升农业农村生产智能化、经营网络化、管理高效化、服务便捷化水平，用数字化引领驱动农业农村现代化，为实现乡村全面振兴提供有力支撑。</p>
      <ul class="clear">
        <li>
          <div class="img"></div>
          <p>大田数字服务平台</p>
        </li>
        <li>
          <div class="img"></div>
          <p>设施种植数字服务平台</p>
        </li>
        <li>
          <div class="img"></div>
          <p>畜禽养殖数字服务平台</p>
        </li>
        <li>
          <div class="img"></div>
          <p>数字渔业服务平台</p>
        </li>
      </ul>
      <div class="button" @click="showDialog = true;systemId= '3'">
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <dialog-box
      :showDialog="showDialog"
      :systemId ="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>
<script>
import dialogBox from './components/dialog'
export default {
  components: {
    dialogBox,
  },
  data() {
    return {
      systemId:'3',
      showDialog: false,
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/pc/css/solution-0.scss";
</style>